/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Button, SimpleGrid} from '@chakra-ui/react'
import usePromoCodeFields from './usePromoCodeFields'
import Field from '../field'

const PromoCodeFields = ({form, prefix = '', ...props}) => {
    const fields = usePromoCodeFields({form, prefix})
    const code = form.watch('code')

    return (
        <SimpleGrid spacing={2} autoFlow="column" autoColumns="1fr" {...props}>
            <Field {...fields.code} />
            <Button
                type="submit"
                isLoading={form.formState.isSubmitting}
                disabled={code?.length < 3}
            >
                <FormattedMessage defaultMessage="Apply" id="promo_code_fields.button.apply" />
            </Button>
        </SimpleGrid>
    )
}

PromoCodeFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default PromoCodeFields
